import CascaderPanel from './src/cascader-panel';

CascaderPanel.install = function(Vue) {
  Vue.component(CascaderPanel.name, CascaderPanel);
};

export default CascaderPanel;



// WEBPACK FOOTER //
// ./src/components/cascader-panel/index.js